import React, { Component } from 'react';
import { connect } from 'react-redux';
import OrderStep from '../components/atoms/OrderStep';
import { contentChange } from '../actions/content';

var AppConfig = require('../config.json');

const ordersteps = [
  {
    number: 1,
    label: AppConfig.links.bundles.label,
    link: AppConfig.links.bundles.url,
    statusSet: AppConfig.links.bundles.statusBeforeRequired
  },
  {
    number: 2,
    label: AppConfig.links.options.label,
    link: AppConfig.links.options.url,
    statusSet: AppConfig.links.options.statusBeforeRequired
  },
  {
    number: 3,
    label: AppConfig.links.payment.label,
    link: AppConfig.links.payment.url,
    statusSet: AppConfig.links.payment.statusBeforeRequired
  },
  {
    number: 4,
    label: AppConfig.links.order.label,
    link: AppConfig.links.order.url,
    statusSet: AppConfig.links.order.statusBeforeRequired
  },
  {
    number: 5,
    label: AppConfig.links.checkout.label,
    link: AppConfig.links.checkout.url,
    statusSet: AppConfig.links.checkout.statusBeforeRequired
  }
];


class OrderStepper extends Component {
  constructor(props) {
    super(props);
    this.clickStep = this.clickStep.bind(this);
  }

  clickStep(clickable, link) {
    if(!clickable || this.props.pathname==='/'+link) {
      return;
    }
    this.props.dispatch(contentChange(link));
  }

  payeverVisible() {
    if(this.props.pathname === "/"+AppConfig.links.payever.url) {
      return true;
    }
    if(this.props.pathname === "/"+AppConfig.links.checkout.url && this.props.status.payment.type==='sf') {
      return true;
    }
    return false;
  }

  stepBeforeCurrentPath(num) {
    for (var i = 0; i < ordersteps.length; i++) {
      if('/'+ordersteps[i].link===this.props.pathname) {
        if(num-1<i) {
          return true;
        }
        break;
      }
    }
    return false;
  }

  getStep(step) {
    var clickable = this.props.status[step.statusSet].isset;
    var highlighted = clickable && this.stepBeforeCurrentPath(step.number);
    var active = this.props.pathname === '/'+step.link;
    if(this.payeverVisible() && step.link!==AppConfig.links.checkout.url && step.link!==AppConfig.links.finished.url) {
      highlighted = true;
    }
    
    return <OrderStep action={this.clickStep} key={`step_${step.number}`} highlighted={highlighted} clickable={clickable} active={active} label={step.label} link={step.link} number={step.number} />
  }

  render() {
    const stepsVisible = this.props.pathname === "/"+AppConfig.links.login.url || this.props.pathname === "/"+AppConfig.links.finished.url ? false : true;
    return (
      <div id="ordersteps" className={`${stepsVisible?"active":""}${this.props.isLoggingOut?" logout":""}${this.payeverVisible()?" payever":""}`}>
        {
          ordersteps.map(step => this.getStep(step))
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pathname: state.routing.location.pathname,
    status: state.status,
    isLoggingOut: state.auth.isLoggingOut
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderStepper)


// WEBPACK FOOTER //
// ./src/utils/OrderStepper.js